module.exports = __webpack_public_path__ + "static/media/studi2.bf4633f2.png";